<template>
  <v-dialog v-model="dialog" scrollable width="720">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" depressed color="chip" small>
        <div class="text-capitalize">Görüntüle</div>
      </v-btn>
    </template>

    <v-card
      :class="{
        'scrollable-card': !isScroll,
        'scrollable-text-card': !isScroll && $vuetify.breakpoint.mdAndDown,
        'scrollable-not-card': !isScroll && arrivedState.bottom,
      }"
    >
      <v-card-title class="grey">
        <div
          class="d-flex align-center justify-space-between"
          style="width: 100%"
        >
          <div class="d-flex align-center">
            <v-icon color="white" size="48">
              {{ icons.mdiCashRegister }}
            </v-icon>

            <div class="text-h5 font-weight-bold ms-3 white--text">
              {{ cashData.form_date }} Kasa Raporu
            </div>
          </div>
          <v-btn color="grey" depressed fab @click="closeForm()">
            <v-icon large>
              {{ icons.mdiCloseCircleOutline }}
            </v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-divider />
      <v-alert class="ma-0" prominent :type="cashData.statustype" text>
        <div class="font-weight-bold">
          {{ cashData.statustxt }}
        </div>
        <div class="text-caption">
          {{ cashData.cancel_reason }}
        </div>
      </v-alert>

      <v-card-text class="pa-0" ref="scrollableEl" style="height: 100svh">
        <v-row no-gutters>
          <v-col
            v-for="(medya, i) in cashData.medyalar"
            :key="i"
            cols="6"
            md="4"
          >
            <v-card flat color="primary" style="height: 100%" tile>
              <v-row no-gutters style="height: 100%">
                <v-col cols="12" style="height: calc(100% - 30px)">
                  <v-img :src="medya.dosya_adi"
                /></v-col>
                <v-col :cols="cashData.status == 'FRST' && userData.role === 'SUBE' ? 6 : 12">
                  <v-btn
                    depressed
                    tile
                    small
                    block
                    color="secondary"
                    @click="openUrl(medya.dosya_adi)"
                    >Büyüt</v-btn
                  >
                </v-col>
                <v-col
                  cols="6"
                  v-if="cashData.status == 'FRST' && userData.role === 'SUBE'"
                >
                  <v-btn
                    @click="store.imageDeleteFn(cashData.id, medya.uploadid)"
                    block
                    small
                    tile
                    depressed
                    color="error"
                    >sil</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-divider />
        <v-data-table
          hide-default-footer
          hide-default-header
          :headers="headers"
          :items="items"
          :items-per-page="-1"
        >
          <template v-slot:item.name="{ item }">
            <div class="text-subtitle-1 white--text">
              {{ item.name }}
            </div>
            <div v-if="item.desc !== 'null'">
              {{ item.desc }}
            </div>
          </template>
          <template v-slot:item.value="{ item }">
            <div class="text-subtitle-1">
              {{ item.value | currency() }}
            </div>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-actions> </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { ref, watch } from "vue-demi";

// Pinia
import { useCashReportStore } from "./store";

// Utils
import { useScroll, useResizeObserver } from "@vueuse/core";
import { useToast } from "vue-toastification/composition";

// Icons
import { mdiCashRegister, mdiCloseCircleOutline } from "@mdi/js";

export default {
  props: ["data"],
  setup(props, { emit }) {
    const toast = useToast();
    const store = useCashReportStore();
    const dialog = ref(false);
    const userData = JSON.parse(localStorage.getItem("userData"));

    // Kaydırma çubuğu
    const scrollableEl = ref(null);
    const { arrivedState } = useScroll(scrollableEl);
    const isScroll = ref(false);

    // Ekran boyutu algılama
    useResizeObserver(scrollableEl, (entries) => {
      isScroll.value =
        scrollableEl.value?.scrollHeight === scrollableEl?.value.offsetHeight;
    });

    const closeForm = () => {
      dialog.value = false;
    };
    const openUrl = (url) => {
      window.open(url, "_blank");
    };
    const cashData = ref({});

    const headers = [
      {
        text: "",
        align: "start",
        sortable: false,
        value: "name",
      },

      {
        text: "",
        align: "end",
        sortable: false,
        value: "value",
      },
    ];
    const items = ref([]);
    watch(dialog, (val) => {
      if (val) {
        isScroll.value =
          scrollableEl.value?.scrollHeight === scrollableEl.value?.offsetHeight;
        cashData.value = props.data;

        items.value = [
          {
            name: "Bankaya Yatan Tutar",
            value: cashData.value.banka_yatan_tutar,
            desc: cashData.value.banka_yatan_tutar_aciklama,
          },
          {
            name: "Nakit İade Tutar",
            value: cashData.value.nakit_iade_tutar,
            desc: cashData.value.nakit_iade_tutar_aciklama,
          },
          {
            name: "Kapanıştakı Sayılan Nakit Tutar",
            value: cashData.value.kapanis_nakit_tutar,
            desc: cashData.value.kapanis_nakit_tutar_aciklama,
          },
          {
            name: "Nakit Gelir",
            value: cashData.value.gelir_nakit,
            desc: cashData.value.gelir_nakit_aciklama,
          },
          {
            name: "Kredi Kartı Gelir",
            value: cashData.value.gelir_kredikarti,
            desc: cashData.value.gelir_kredikarti_aciklama,
          },
          {
            name: "Toplam Cari",
            value: cashData.value.toplam_cari,
            desc: cashData.value.toplam_cari_aciklama,
          },
          {
            name: "Getir",
            value: cashData.value.gelir_getir,
            desc: cashData.value.gelir_getir_aciklama,
          },
          {
            name: "Yemek Sepeti",
            value: cashData.value.gelir_yemeksepeti,
            desc: cashData.value.gelir_yemeksepeti_aciklama,
          },
          {
            name: "Trendyol",
            value: cashData.value.gelir_trendyol,
            desc: cashData.value.gelir_trendyol_aciklama,
          },
          {
            name: "Diğer Online Ödemeler",
            value: cashData.value.gelir_digeronline,
            desc: cashData.value.gelir_digeronline_aciklama,
          },
          {
            name: "Metropol",
            value: cashData.value.gelir_metropol,
            desc: cashData.value.gelir_metropol_aciklama,
          },
          {
            name: "Multinet",
            value: cashData.value.gelir_multinet,
            desc: cashData.value.gelir_multinet_aciklama,
          },
          {
            name: "Setcard",
            value: cashData.value.gelir_setcard,
            desc: cashData.value.gelir_setcard_aciklama,
          },
          {
            name: "Sodexo",
            value: cashData.value.gelir_sodexo,
            desc: cashData.value.gelir_sodexo_aciklama,
          },
          {
            name: "Edenred / Ticket",
            value: cashData.value.gelir_edenred,
            desc: cashData.value.gelir_edenred_aciklama,
          },
          {
            name: "Diğer Yemek Çekleri",
            value: cashData.value.gelir_yk_diger,
            desc: cashData.value.gelir_yk_diger_aciklama,
          },
        ];
      }
    });

    return {
      store,
      userData,

      dialog,
      cashData,
      headers,
      items,
      isScroll,
      arrivedState,
      scrollableEl,
      openUrl,

      closeForm,
      icons: {
        mdiCashRegister,
        mdiCloseCircleOutline,
      },
    };
  },
};
</script>
